module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Amy M Bennett\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Amy M. Bennett was born and raised in El Paso, Texas. "), _c('I', [_vm._v("End of the Road")]), _vm._v(" started as a project for National Novel Writing Month in 2009 but it went on to win Oak Tree Press’s 2012 Dark Oak Mystery contest. Her first and second books in the series, "), _c('I', [_vm._v("End of the Road")]), _vm._v(" and "), _c('I', [_vm._v("No Lifeguard on Duty")]), _vm._v(", were both awarded the Catholic Writers Guild Seal of Approval. She and her husband Paul currently reside in Bent, New Mexico, with their son, Paul Michael."), _c('BR'), _vm._v("  ")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/LfFCZh/tc-custom/9781504090988.jpg?1731154339291",
      "alt": "This image is the cover for the book At the Crossroad, Black Horse Campground Mysteries"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("At the Crossroad, Black Horse Campground Mysteries\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("You can take the cop out of the big city, but you can’t take the big city out of the cop, in this fourth Black Horse Campground mystery.")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Just as Corrie is getting used to having former Houston, Texas, narcotics detective J. D. Wilder as a campground employee, he officially becomes a member of the Village of Bonney Police Department. Aside from a recent crime spree at the Black Horse, not much is going on in town, giving Wilder a chance to go over some cold cases."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" In the past fifteen years, three women have gone missing, exactly five years apart. What has amounted to nothing more than a local urban legend becomes Wilder’s new obsession—with Corrie offering some much-needed background information. As he’s digging into the neighborhood’s recent history, trouble from his own shows up, forcing the shadowy past into a deadly confrontation with a clear and present danger . . ."), _c('br')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Open Road Media\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0